import { DeleteRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useGetProducts } from "./useGetProducts"
import { ProductEntity } from "../../Objects/ProductsAndCatalogItems/ProductEntity"
import { useTranslation } from "react-i18next"

export const useRemoveProduct = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetProducts } = useGetProducts()

  const handleRemove = async (product: ProductEntity, onSuccess: any) => {
    try {
      enableLoad()

      var response = await DeleteRequest(`${API_ROUTES.PRODUCT.DELETE}/${product.id}`)

      if (response.success) {
        await handleGetProducts(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleRemove,
  }
}
